export enum ResponseItemPriority {
  None = 0,
  P3 = 3,
  P4 = 4,
  P5 = 5,
}
